import React from 'react';
import { Toaster as Sonner } from 'sonner';
import { Icons } from '../Icons';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      loadingIcon={<Icons.LoadingSpinner />}
      icons={{
        warning: <Icons.StatusWarning />,
        info: <Icons.Info className="text-primary" />,
        success: <Icons.StatusSuccess />,
        error: <Icons.StatusError />,
      }}
      style={
        {
          // Map Sonner's internal CSS variables to the active theme tokens.
          // These cascade into every toast so background/text/border always
          // match whichever theme is applied to <body>.
          '--normal-bg': 'hsl(var(--card))',
          '--normal-border': 'hsl(var(--border))',
          '--normal-text': 'hsl(var(--card-foreground))',
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          width: '430px',
          right: '8px',
        },
        classNames: {
          toast: '!bg-card !border-border !text-card-foreground shadow-md',
          title: '!text-card-foreground font-medium',
          description: '!text-muted-foreground',
          actionButton: '!bg-primary !text-primary-foreground',
          cancelButton: '!bg-muted !text-muted-foreground',
          // Left-border accent per type — indicates severity using theme colour
          info: 'border-l-4 !border-l-primary',
          success: 'border-l-4 border-l-green-500',
          error: 'border-l-4 !border-l-destructive',
          warning: 'border-l-4 border-l-yellow-500',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
